import { Schema } from 'normalizr';

import SingletonDuckEntity from './SingletonDuckEntity';

const entity = new SingletonDuckEntity(
  'quickbooksConfig', { schema: new Schema('quickbooksConfig') }
);

export { entity as quickbooksConfig };